module.exports = __webpack_public_path__ + "static/integrately-e221ec510f2b56fa335cc03bda355f6c.svg";